@if (status() === 'pending') {
  <svg-icon
    class="max-h-4 max-w-4 text-text-light"
    key="px-24-hourglass"
    [libUiTooltip]="nsStatusTooltip"
    [tooltipPosition]="'bottom'"
  ></svg-icon>
  <ng-template #nsStatusTooltip>
    <div class="px-3 py-2">
      <div class="typo-h7-light">{{ 'health_history_prescriptions_tab_ns_provisional_tooltip' | translate }}</div>
    </div>
  </ng-template>
}

@if (status() === 'non-standard') {
  <svg-icon class="max-h-4 max-w-4 text-primary-blue" key="px-16-check"></svg-icon>
}
